import { render, staticRenderFns } from "./SpeakerBrowserNotSupportedMessage.vue?vue&type=template&id=2c80d310&scoped=true&"
import script from "./SpeakerBrowserNotSupportedMessage.vue?vue&type=script&lang=js&"
export * from "./SpeakerBrowserNotSupportedMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80d310",
  null
  
)

export default component.exports